// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___xUKz","colBig":"styles_colBig__3S0Uc","colSmall":"styles_colSmall__3bjfw"};